import * as React from "react";
import * as ReactDOM from "react-dom";
import { Application } from "./modules/application";
import registerServiceWorker from "./registerServiceWorker";
import "./sass/main.css";

ReactDOM.render(<Application />, document.getElementById(
  "root"
) as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx